import { apiResponse, defaultAgent } from "../helpers/web-agent";
import { toastError, toastSuccess } from "./toast";
import { tokenExpired } from "./auth";
import {
    OEM_MAKE_LIST, OEM_MAKE_LIST_REQUESTING, OEM_UNKNOWN_DEVICE,
    OEM_UNKNOWN_DEVICE_REQUESTING,
    USER_OEM_LIST,
    USER_OEM_LIST_REQUESTING
} from "../constants/action-types";


export const OEMMakeList = (data) => ({ type: OEM_MAKE_LIST, payload: data });
export const OEMMakeListRequest = (data) => ({ type: OEM_MAKE_LIST_REQUESTING, payload: data });

export const OemUnknownDevice = (data) => ({ type: OEM_UNKNOWN_DEVICE, payload: data });
export const OemUnknownDeviceRequest = (data) => ({ type: OEM_UNKNOWN_DEVICE_REQUESTING, payload: data });

export const UserOEMList = (data) => ({ type: USER_OEM_LIST, payload: data });
export const UserOEMListRequest = (data) => ({ type: USER_OEM_LIST_REQUESTING, payload: data });

export const getOEMMakeList = () => dispatch => {
    dispatch(OEMMakeListRequest());
    defaultAgent.get(`api/oem/make/list`).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(OEMMakeList(agentResult.data));
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const getOemUnknownDevice = () => dispatch => {
    dispatch(OemUnknownDeviceRequest());
    defaultAgent.get(`api/oem/unknown/device`).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(OemUnknownDevice(agentResult.data));
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
}

export const getUserOEMMakeList = (req = {}) => dispatch => {
    dispatch(UserOEMListRequest());
    defaultAgent.get(`api/oem/assigned`, req).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(UserOEMList(agentResult.data));
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const OEMUserAssign = (data, cb) => dispatch => {
    defaultAgent.post('api/oem/user/assign', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === 2080 || agentResult.code === 2082) {
                if (cb) cb(true);
                dispatch(toastSuccess(agentResult.message));
            } else if (agentResult.message) {
                if (cb) cb(false);
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            if (cb) cb(false);
            dispatch(toastError(ex.message));
        });
}